var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignagePrinting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-48020f6f-271d-4094-996f-ae3bc3d43c64",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.1,
    height: 50.9,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 76.1 50.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-ed3f9d88-ee7a-4706-9eab-30bec0b0467c{stroke:url(#uuid-215e7286-09ad-4d4c-bb64-396cf28dca7e);}.uuid-ed3f9d88-ee7a-4706-9eab-30bec0b0467c,.uuid-5ab452e2-d544-4529-a08e-70b653da72d0,.uuid-8ee0d612-2cda-4582-b28e-ba586ef35f31,.uuid-e5b43c7e-a113-4e7e-9f16-18d9cc4ddeac,.uuid-11ff3e01-45e8-4540-8629-bc5e325e0015{fill:none;stroke-miterlimit:10;}.uuid-5ab452e2-d544-4529-a08e-70b653da72d0{stroke:url(#uuid-a62f71c8-8bf5-456c-9fb1-18b85352a89f);}.uuid-8ee0d612-2cda-4582-b28e-ba586ef35f31{stroke:url(#uuid-42ace78b-0f2d-4acf-a6ac-8f7e9b58f630);}.uuid-e5b43c7e-a113-4e7e-9f16-18d9cc4ddeac{stroke:url(#uuid-97f1dfa2-eea2-4632-aa2d-e31b793f8ad2);}.uuid-11ff3e01-45e8-4540-8629-bc5e325e0015{stroke:url(#uuid-edbf6171-fbc2-4c17-8756-fdde9e4daf4b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-97f1dfa2-eea2-4632-aa2d-e31b793f8ad2",
    x1: 0,
    y1: 9.9,
    x2: 76.1,
    y2: 9.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f37525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fab73d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-215e7286-09ad-4d4c-bb64-396cf28dca7e",
    x1: 2.5,
    y1: 33.3,
    x2: 73.7,
    y2: 33.3,
    xlinkHref: "#uuid-97f1dfa2-eea2-4632-aa2d-e31b793f8ad2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-edbf6171-fbc2-4c17-8756-fdde9e4daf4b",
    x1: 0,
    y1: 27.9,
    x2: 76,
    y2: 27.9,
    xlinkHref: "#uuid-97f1dfa2-eea2-4632-aa2d-e31b793f8ad2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a62f71c8-8bf5-456c-9fb1-18b85352a89f",
    x1: 7.7,
    y1: 3.7,
    x2: 68.4,
    y2: 3.7,
    xlinkHref: "#uuid-97f1dfa2-eea2-4632-aa2d-e31b793f8ad2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-42ace78b-0f2d-4acf-a6ac-8f7e9b58f630",
    x1: 18.2,
    y1: 0.7,
    x2: 57.9,
    y2: 0.7,
    xlinkHref: "#uuid-97f1dfa2-eea2-4632-aa2d-e31b793f8ad2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-7e463008-a5fa-4b3f-9d8a-691c18461e4b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5b43c7e-a113-4e7e-9f16-18d9cc4ddeac",
    d: "M75.5,13.4H.6c-.2-3.3-.1-6.3,3.7-6.9h66.5c4.7.3,4.9,2.7,4.7,6.9ZM51.8,9.6h-27.5v1h27.5v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-ed3f9d88-ee7a-4706-9eab-30bec0b0467c",
    d: "M66.8,16.2c-3.3,7.3-5.5,15.5-1.1,22.9l7,10.6c-1.1,0-2.2.3-3.3.4-20.5,1.3-42.2-1-62.8,0l-3.3-.5c3.5-5.3,8.8-10,9.4-16.7.5-5.6-1.3-11.5-3.5-16.5h57.5ZM63.3,17.9H12.4c3.6,9.5,3.9,19.7-3.3,27.5-1.1,1.2-2.4,1.9-3.3,3.1h63.4l-5.4-7.3c-4.1-7.4-4.6-15.8-.5-23.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-11ff3e01-45e8-4540-8629-bc5e325e0015",
    d: "M75.5,13.7v7.1c0,.4-1.7,2.1-2.2,2.3-1.3.6-2.8.2-3.7.8v17.4l-.9.5-1.2-1.6.3-16.5c-1,0-2.1.3-2.8-.5l3.1-8.2H7.9l3.1,8.2c-.6.8-1.6.5-2.4.5,0,4.4-.1,8.7,0,13.1s1.2,3.4-1.2,5l-.9-.5v-17.4l-.5-.4c-1.4.9-5.4-1.3-5.4-2.7v-7.1h74.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5ab452e2-d544-4529-a08e-70b653da72d0",
    d: "M67.8,5.7H8.2c0-1.5-.2-3,1-4h57.5c1.3,1,1.1,2.5,1,4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-8ee0d612-2cda-4582-b28e-ba586ef35f31",
    x: 18.7,
    y: 0.5,
    width: 38.7,
    height: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignagePrinting);
export default __webpack_public_path__ + "static/media/Signage Printing.612c3355df0bb01691c8d0468824b58a.svg";
export { ForwardRef as ReactComponent };